import { API_ENDPOINTS } from "../config/api";

const getBaseUrl = () => (API_ENDPOINTS.MEDIA_BASE_URL || API_ENDPOINTS.BASE_URL || "").replace(/\/+$/, "");

const isAbsoluteUrl = (value) => /^https?:\/\//i.test(value);

export const normalizeMediaUrl = (value) => {
  if (!value || typeof value !== "string") {
    return value;
  }
  if (value.startsWith("data:") || value.startsWith("blob:")) {
    return value;
  }

  const baseUrl = getBaseUrl();
  if (!baseUrl) {
    return value;
  }

  if (isAbsoluteUrl(value)) {
    if (value.includes("/media/")) {
      const pathOnly = value.replace(/^https?:\/\/[^/]+/, "");
      return `${baseUrl}${pathOnly.startsWith("/") ? "" : "/"}${pathOnly}`;
    }
    return value;
  }

  if (value.startsWith("/media/") || value.startsWith("media/")) {
    const pathOnly = value.startsWith("/") ? value : `/${value}`;
    return `${baseUrl}${pathOnly}`;
  }

  return value;
};

export const normalizeImageObject = (image) => {
  if (!image || typeof image !== "object") {
    return image;
  }
  const normalized = { ...image };
  const keys = ["image_url", "image", "url", "thumbnail_url", "thumbnail"];
  keys.forEach((key) => {
    if (typeof normalized[key] === "string") {
      normalized[key] = normalizeMediaUrl(normalized[key]);
    }
  });
  if (image.srcset && typeof image.srcset === "object") {
    normalized.srcset = Object.fromEntries(
      Object.entries(image.srcset).map(([width, url]) => [width, normalizeMediaUrl(url)])
    );
  }
  return normalized;
};

export const normalizeCategory = (category) => {
  if (!category || typeof category !== "object") {
    return category;
  }
  const normalized = { ...category };
  if (normalized.sample_product_image) {
    normalized.sample_product_image = normalizeImageObject(normalized.sample_product_image);
  }
  if (typeof normalized.image === "string") {
    normalized.image = normalizeMediaUrl(normalized.image);
  }
  if (typeof normalized.thumbnail === "string") {
    normalized.thumbnail = normalizeMediaUrl(normalized.thumbnail);
  }
  return normalized;
};

export const normalizeProduct = (product) => {
  if (!product || typeof product !== "object") {
    return product;
  }
  const normalized = { ...product };
  if (typeof normalized.flagship_image === "string") {
    normalized.flagship_image = normalizeMediaUrl(normalized.flagship_image);
  }
  if (normalized.highlight_image) {
    normalized.highlight_image = normalizeImageObject(normalized.highlight_image);
  }
  if (Array.isArray(normalized.images)) {
    normalized.images = normalized.images.map(normalizeImageObject);
  }
  if (Array.isArray(normalized.image)) {
    normalized.image = normalized.image.map(normalizeMediaUrl);
  } else if (typeof normalized.image === "string") {
    normalized.image = normalizeMediaUrl(normalized.image);
  }
  if (normalized.category) {
    normalized.category = normalizeCategory(normalized.category);
  }
  // Normalize capability images
  if (Array.isArray(normalized.capabilities)) {
    normalized.capabilities = normalized.capabilities.map((capability) => {
      if (!capability || typeof capability !== "object") {
        return capability;
      }
      const normalizedCapability = { ...capability };
      if (Array.isArray(normalizedCapability.images)) {
        normalizedCapability.images = normalizedCapability.images.map(normalizeImageObject);
      }
      return normalizedCapability;
    });
  }
  return normalized;
};
